module.exports = __webpack_public_path__ + "static/media/attachment.d8ac430b.svg";